






























































































































































































import FlMap from '@/components/FlMap.vue';
import { subMonths, addDays } from 'date-fns';
import AccessChart from '@/components/AccessChart.vue';
import AccessLogTable from '@/components/AccessLogTable.vue';
import { QuoteMixin, PriceMixin, SlackMixin, UserMixin } from '@/Mixin';
import { month } from '@/components/const/SelectMovieOptions';

export default {
  name: 'AccessLogs',
  components: {
    FlMap,
    AccessChart,
    AccessLogTable,
  },
  mixins: [QuoteMixin, PriceMixin, SlackMixin, UserMixin],
  data() {
    return {
      months: 1,
      logs: [],
      logsMeta: {},
      quotes: [],
      carts: [],
      totalFlatPrice: 0,
      totalMGPrice: 0,
      totalAverageRSPrice: 0,
    };
  },
  async mounted() {
    await Promise.all([this.getLogs(), this.getQuotes(), this.getCarts()]);
  },
  methods: {
    async getLogs() {
      const result = await this.axios.get('/access_logs', { params: { months: this.months } });
      this.logs = result.data.data;
      this.logsMeta = result.data.meta;
      if (this.logsMeta.last_page > 1) {
        for (let i = 2; i < this.logsMeta.last_page; i++) {
          const tmp = await this.axios.get('/access_logs', { params: { months: this.months, page: i } });
          this.logs = [...this.logs, ...tmp.data.data];
        }
      }
    },
    async getQuotes() {
      const result = await this.axios.get('/quotes', { params: { status: '5,6,7,9,10' } });
      this.quotes = result.data.data;
      const meta = result.data.meta;
      if (meta.last_page > 1) {
        for (let i = 2; i < meta.last_page; i++) {
          const tmp = await this.axios.get('/quotes', { params: { status: '5,6,7,9,10', page: i } });
          this.quotes = [...this.quotes, ...tmp.data.data];
        }
      }

      this.totalFlatPrice = 0;
      this.totalMGPrice = 0;
      this.totalAverageRSPrice = 0;

      this.quotes.map(async (quote) => {
        const qms = quote.movies.map((movie) => this.axios.get(`/quote_movie/${movie.uuid}`));
        const tmp = await Promise.all(qms);
        const quoteMovies = tmp.map((q) => (q as any).data.data);

        if (quote.pricing_type === 1) {
          this.totalFlatPrice += this.customerTotalPrice(
            quoteMovies,
            this.showInYen(quote, (this.quotesSingleMax(quote) + this.quotesSingleMin(quote)) / 2) +
              this.adjustmentTotal(quote, quoteMovies)
          );
        } else if (quote.pricing_type === 2) {
          if (quote.price_minimum_guarantee) {
            this.totalMGPrice += this.customerTotalPrice(
              quoteMovies,
              this.showInYen(quote, (this.quotesSingleMax(quote) + this.quotesSingleMin(quote)) / 2) +
                this.adjustmentTotal(quote, quoteMovies)
            );
          } else {
            this.totalAverageRSPrice += this.customerTotalPrice(
              quoteMovies,
              this.showInYen(quote, (this.quotesSingleMax(quote) + this.quotesSingleMin(quote)) / 2) +
                this.adjustmentTotal(quote, quoteMovies)
            );
          }
        }

        // this.totalFlatPrice += this.providerTotalFlat(quote);
        // this.totalMGPrice += this.providerTotalMG(quote, quoteMovies.data.data);
        // this.totalAverageRSPrice += this.customerTotalPrice(quoteMovies.data.data, this.showInYen(quote, (this.quotesSingleMax(quote) + this.quotesSingleMin(quote)) / 2)) + this.adjustmentTotal(quote, quoteMovies.data.data);
      });

    },
    async getCarts() {
      const result = await this.axios.get('/carts');
      this.carts = result.data.data;
    },
    async sendRequestToSlack(title: string) {
      const url = new URL(window.location.href);
      const message = `${(this as any).loginUserName}様(${
        (this as any).loginEmail
      })のプレミアムサービスから${title}の申請依頼がきました。`;
      await (this as any).sendSlackMessage(message, '_paid-services');
      //reset
      this.$modal.show('sentPremiumRequestModal');
    },
  },
  computed: {
    countries() {
      const vodCountriesWithOverlap = [];
      this.logs.map((log) => {
        if (log.viewedBy.hq_country) {
          vodCountriesWithOverlap.push(log.viewedBy.hq_country.toLowerCase());
        }
      });

      return [...new Set(vodCountriesWithOverlap)];
    },
    percentage() {
      const total = this.logsMeta.total / this.months;
      if (total < 41) {
        return '0.0';
      } else if (total < 108) {
        return '0.5';
      } else if (total < 166) {
        return '1.0';
      } else if (total < 205) {
        return '1.5';
      } else if (total < 254) {
        return '2.0';
      } else if (total < 303) {
        return '2.5';
      } else if (total < 377) {
        return '3.0';
      } else if (total < 402) {
        return '3.5';
      } else {
        return '4.0';
      }
    },
  },
};
